// ============================================================
// Teacher Dashboard Mock Data
// ============================================================

export const mockTeacherDashboardData = {
  'teacher-1': {
    todaysClasses: [
      { period: 1, subject: 'Mathematics', className: 'Grade 1', sectionName: 'Section A', room: 'Room 101', time: '08:00 - 08:45' },
      { period: 3, subject: 'Mathematics', className: 'Grade 1', sectionName: 'Section B', room: 'Room 102', time: '09:30 - 10:15' },
      { period: 5, subject: 'Mathematics', className: 'Grade 2', sectionName: 'Section A', room: 'Room 201', time: '11:15 - 12:00' },
    ],
    stats: {
      totalClasses: 3,
      totalSubjects: 1,
      totalStudents: 86,
      classTeacherOf: 'Grade 1 - Section A',
    },
    attendanceSummary: {
      present: 78,
      absent: 5,
      late: 2,
      leave: 1,
      total: 86,
    },
    homeworkSummary: {
      pending: 2,
      submitted: 5,
      reviewed: 12,
    },
  },
  'teacher-2': {
    todaysClasses: [
      { period: 2, subject: 'Science', className: 'Grade 2', sectionName: 'Section A', room: 'Lab 1', time: '08:45 - 09:30' },
      { period: 4, subject: 'Science', className: 'Grade 2', sectionName: 'Section B', room: 'Lab 1', time: '10:15 - 11:00' },
      { period: 6, subject: 'Physics', className: 'Grade 3', sectionName: 'Section A', room: 'Lab 2', time: '12:00 - 12:45' },
    ],
    stats: {
      totalClasses: 3,
      totalSubjects: 2,
      totalStudents: 92,
      classTeacherOf: 'Grade 2 - Section A',
    },
    attendanceSummary: {
      present: 84,
      absent: 4,
      late: 3,
      leave: 1,
      total: 92,
    },
    homeworkSummary: {
      pending: 3,
      submitted: 4,
      reviewed: 8,
    },
  },
  'teacher-3': {
    todaysClasses: [
      { period: 1, subject: 'English', className: 'Grade 1', sectionName: 'Section A', room: 'Room 101', time: '08:00 - 08:45' },
      { period: 3, subject: 'English', className: 'Grade 3', sectionName: 'Section A', room: 'Room 301', time: '09:30 - 10:15' },
      { period: 5, subject: 'English', className: 'Grade 4', sectionName: 'Section A', room: 'Room 401', time: '11:15 - 12:00' },
    ],
    stats: {
      totalClasses: 3,
      totalSubjects: 1,
      totalStudents: 88,
      classTeacherOf: 'Grade 3 - Section A',
    },
    attendanceSummary: {
      present: 80,
      absent: 6,
      late: 1,
      leave: 1,
      total: 88,
    },
    homeworkSummary: {
      pending: 1,
      submitted: 6,
      reviewed: 15,
    },
  },
};
